import React, { Component } from 'react'
import { bindActionCreators, compose } from 'redux'
import { connect } from 'react-redux'
import PropTypes from 'prop-types'
import Divider from 'material-ui/Divider'
import { logout } from '../modules/authProfile'
import Messages from '../constants/messages'
import Paper from 'material-ui/Paper'
import Typography from 'material-ui/Typography'
import withStyles from 'material-ui/styles/withStyles'
import { Link } from 'react-router-dom'

const PROP_TYPES = {
  classes: PropTypes.object.isRequired
}

const styles = theme => ({
  root: {
    minWidth: 320,
    maxWidth: 600,
    width: '30%',
    margin: 'auto'
  },
  copyright: {
    display: 'inline-block',
    width: '100%',
    textAlign: 'left'
  },
  divider: {
    marginTop: 25,
    marginBottom: 25
  },
  footer: {
    position: 'fixed',
    bottom: 0,
    padding: 10,
    fontSize: 12
  },
  header: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center'
  },
  nordstromLogo: {
    width: '70%',
    paddingBottom: 30
  },
  paper: theme.mixins.gutters({
    paddingTop: 16,
    paddingBottom: 16,
    marginTop: theme.spacing.unit * 3
  })
})

export class Unauthorized extends Component {

  render() {
    const { classes, logout } = this.props

    return (
      <section>
        <section className={classes.root}>
          <Paper className={classes.paper} elevation={4} id="unauthorized">
            <header className={classes.header}>
              <img
                data-test-id="nordstrom-logo"
                src="https://s3-us-west-2.amazonaws.com/nauth-prod/Design+Assets/nord_logo/nord_logo_black%402x.png"
                className={classes.nordstromLogo}
                alt="nordstrom logo" />
                <Typography className={classes.paddingBot} type="display1">{Messages['uiComponents']['APPLICATION_NAME']}</Typography>
            </header>
            <Divider className={classes.divider} />
            <Typography type="title" gutterBottom>
              {Messages['pageHeaders']['UNAUTHORIZED_TITLE']}
            </Typography>
            <Typography>
              {Messages['pageMessages']['UNAUTHORIZED_MSG'] + ' '}
              <Link to={'/loggedOut'} onClick={() => logout()}>{Messages['pageMessages']['UNAUTHORIZED_MSG_LOGOUT']}</Link>
            </Typography>
          </Paper>
        </section>
        <footer className={classes.footer}>
          <span className={classes.copyright} data-test-id="nordstrom-copy">&copy; {`${(new Date()).getFullYear()} Nordstrom, Inc.`}</span>
        </footer>
      </section>
    )
  }
}

Unauthorized.propTypes = PROP_TYPES

const mapStateToProps = state => ({

})

const mapDispatchToProps = dispatch => bindActionCreators({
  logout
}, dispatch)

export default compose(
  withStyles(styles),
  connect(
    mapStateToProps,
    mapDispatchToProps
  ),
)(Unauthorized)
